<template>
    <div id="edit_user_info">
        <div class="edit_user_info_content" v-if="isLoaded">
            <h1 :style="{color: colors.fourth}">Atualize seu perfil</h1>
            <form>
                <div 
                class="input_type_text" 
                v-for="(userInfo, propName) of filterBy('string')" 
                :key="propName">
                    <label for="">{{userInfosTitlesObj[propName].translation}}</label>
                    <input type="email" v-if="propName === 'email'" :placeholder="userInfo" v-model="body[propName]">
                    <input type="number" v-if="propName === 'age'"  :placeholder="userInfo" v-model="body[propName]">
                    <input type="text" 
                    v-if="propName != 'email' && 
                    propName != 'age' && 
                    propName != 'enrollmentCity' && 
                    propName != 'worktimeAvailability'" 
                    :placeholder="userInfo" v-model="body[propName]"> 
                    <select v-model="body[propName]" v-if="propName == 'enrollmentCity'">
                        <option :value="value" v-for="value in enrollmentCityValues" :key="value">{{value}}</option>
                    </select>
                    <select v-model="body[propName]" v-if="propName == 'worktimeAvailability'">
                        <option :value="value" v-for="value in worktimeAvailabilityValues" :key="value">{{value}}</option>
                    </select>
                </div>
                <div 
                class="input_type_object" 
                v-for="(userInfo, propName) of filterBy('object')" 
                :key="propName">
                    <label for="">{{userInfosTitlesObj[propName].translation}}</label>
                    <!-- <input type="" v-model="body[propName]" > -->
                    <div class="item"
                    v-for="(childUserInfo, childPropName) of filterChild(userInfo)" 
                    :key="childPropName">
                        <!-- <label for="">{{userInfosTitlesObj[propName][childPropName].translation}}</label> -->
                        <label for="">{{userInfosTitlesObj[propName][childPropName].translation}}</label>
                        <input type="time" :placeholder="childUserInfo" v-model="body[`${propName}.${childPropName}`]" 
                        v-if="childPropName == 'endLesson' || childPropName == 'startLesson'">
                        <input type="month" :placeholder="childUserInfo" v-model="body[`${propName}.${childPropName}`]" v-if="childPropName == 'conclusion'">
                        <select v-model="body[`${propName}.${childPropName}`]" v-if="childPropName == 'english'">
                            <option :value="prop" v-for="(value, prop) of filterChild(proficiencyValues)" :key="prop">{{value}}</option>
                        </select>
                        <select v-model="body[`${propName}.${childPropName}`]" v-if="childPropName == 'type'">
                            <option :value="value" v-for="(value, prop) of filterChild(graduationType)" :key="prop">{{value}}</option>
                        </select>
                        <input type="text" :placeholder="childUserInfo" v-model="body[`${propName}.${childPropName}`]" 
                        v-if="
                        childPropName != 'endLesson' && 
                        childPropName != 'startLesson' && 
                        childPropName !='conclusion' &&
                        childPropName !='english' &&
                        childPropName !='type' &&
                        childPropName !='enrollmentCity'
                        ">
                    </div>
                </div>
            </form>
            <button class="btn rounded"
                @click="postEditEnrollment(userInfos.id, body)"
                ref='btnEditEnrollment'
                :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">
                enviar
            </button>
            <modal v-if="modal.show" @close="modal.show = false">
                <h3 slot="header">{{modal.title}}</h3>
                <h3 slot="body">{{modal.message}}</h3>
            </modal>
            <!-- <span>Body: {{body}}</span> -->
        </div>
        <Loader v-if="!isLoaded"></Loader>
    </div>
</template>

<script>
import Modal from '../../components/modals/Modal'
import Loader from '../../components/Loaders/LoaderFull'
export default {
    // name: 'editUserInfos',
    components:{
        modal: Modal,
        Loader
    },
    data: () =>({
        userInfos: '',
        colors:'',
        enrollment: '',
        body: {},
        modal:{
            show: false,
            title: '',
            message: ''
        },
        btnSendIsEnable: '',
        isLoaded: false,
        worktimeAvailabilityValues: ['4', '6'],
        proficiencyValues: {basic:'Básico', intermediate:'Intermediário', advanced:'Avançado', fluent:'Fluente'},
        enrollmentCityValues: ["belo horizonte","brasilia","campinas","curitiba","goiania","joinville","porto alegre","rio de janeiro","sao paulo","salvador","fortaleza","piracicaba", "osasco", "recife"],
        graduationType: ["Técnologo","Superior"],
        userInfosTitlesObj: {
            "name":{
                "translation": "Nome"
            },
            "cpf":{
                "translation": "CPF"
            },
            "email":{
                "translation": "E-mail"
            },
            "phone":{
                "translation":"Telefone"
            },
            "age":{
                "translation":"Idade"
            },
            "enrollmentCity":{
                "translation": "Cidade de interesse"
            },
            "worktimeAvailability":{
                "translation": "Disponibilidade de estágio (em horas)"
            },
            "address":{
                "translation": "Endereço",
                "cep":{
                    "translation":"CEP"
                },
                "complement":{
                    "translation":"Complemento"
                },
                "neighborhood":{
                    "translation":"Bairro"
                },
                "state":{
                    "translation":"Estado"
                },
                "city":{
                    "translation":"Cidade"
                },
                "street":{
                    "translation":"Rua"
                },
            },
            "graduation":{
                "translation": "Graduação",
                // "semester":{
                //     "translation":"Semestre"
                // },
                // "period":{
                //     "translation":"Período"
                // },
                "startLesson":{
                    "translation":"Horário de início",
                },
                "endLesson":{
                    "translation":"Horário de término",
                },
                "conclusion":{
                    "translation":"Conclusão"
                },
                "course":{
                    "translation":"Curso"
                },
                "type":{
                    "translation":"Tipo",
                },
                "university":{
                    "translation":"Universidade"
                },
            },
            "language":{
                "translation": "Idioma",
                "english":{
                    "translation":"Inglês"
                },
            }
        },
    }),
    async created(){
        this.userInfos = JSON.parse(localStorage.getItem('enrollment'))
        this.colors = this.$store.getters.getCustomColors
        await this.getEnrollment(this.userInfos.id)
        console.log('User infos: ', this.userInfos)
    },

    methods:{
        async getEnrollment(enrollmentId){
            this.btnSendIsEnable = false
            try {
                let enrollmentReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/${enrollmentId}`)
                console.log('enrollmentReq: ', enrollmentReq.body)
                this.enrollment = enrollmentReq.body
                localStorage.setItem('enrollment', JSON.stringify(this.enrollment))
                this.isLoaded = true
            } catch (error) {
                console.error('Erro na requisição de inscrição: ', error);
            }
        },
        translatePropName(object){

        },
        filterBy(type){
            let filteredProp = {};
            for (const field in this.enrollment) if(typeof this.enrollment[field] === type) filteredProp[field] = this.enrollment[field]
            delete filteredProp.__context
            delete filteredProp.id
            delete filteredProp.password
            delete filteredProp.workspaceId

            return filteredProp
        },
        filterChild(childNode){
            let filteredProp = {};
            let inputType = ''
            for (const field in childNode) {
                filteredProp[field] = childNode[field]
            }
            return filteredProp

        },
        toggleBtnDesabled(isDisabled){
            isDisabled ? this.$refs.btnEditEnrollment.setAttribute('disabled', true) : this.$refs.btnEditEnrollment.removeAttribute('disabled')
        },
        toggleModal(isShowModal, title, message){
            this.modal.title = title
            this.modal.message = message
            isShowModal ? this.modal.show = true : this.modal.show = false
        },
        async postEditEnrollment(enrollmentId, body){
            // console.log(body)
            // for (const prop in body) if(body[prop].length < 2) delete body[prop]
            // if(!body.length){
            //     this.toggleModal(true, 'Campos vazios!', 'Nenhum campo foi alterado')
            //     return
            // }
            this.toggleBtnDesabled(true)
            try {
                let enrollmentReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/${enrollmentId}/flow/next`, body)
                console.log('Edited infos: ', enrollmentReq.body)
                this.toggleModal(true, 'Sucesso!', 'Seus dados foram alterados')
                this.body = {}
            } catch (error) {
                console.error('Erro ao editar o candidato: ', error)
                this.toggleModal(true, 'Erro!', 'houve um problema com a edição dos dados, entre em contato com o e-mail: support@huddlebrasil.zendesk.com')
            }
            this.toggleBtnDesabled(false)

        }
        //TODO: add masked inputs


    }
}
</script>

<style lang="scss" scoped>
#edit_user_info{
    
    .edit_user_info_content{
        padding: 32px;
        
        h1{
            font-size: 36px;
            letter-spacing: 4px;
            font-weight: 100;
            line-height: 45px;
            margin: 0 0 32px 0;
        }
    
        .input_type_text, .input_type_object, .item{
            text-transform: uppercase;
            letter-spacing: 4px;
            font-size: 12px;
            margin: 0 0 23px 15px;    
            display: flex;
            flex-direction: column;
            align-items: flex-start;    
            min-width: 125px;
            width: 50%;
    
            input, select{
                width: 100%;
                border: none;
                border-bottom: 1px solid;
            }
        }
        .input_type_object{
            >label{
                &:first-child{
                    margin: 0 0 15px 0;
                }
            }
            .item{
                margin: 0 0 15px 15px;
            }
        }
        .btn{
            display: flex;
            align-items: center;
            justify-content: center;
    
            &:hover{
                cursor: pointer;
            }
            &:disabled{
                cursor: progress;
                opacity: .3;
            }
    
        }
    }

}
@media screen and (max-width: 530px) { 
    #edit_user_info{
        .edit_user_info_content{
            .input_type_text, .input_type_object, .item{
                width: 90%
            }
        }
    }
}
</style>